import { muiAlert } from "./muiAlert";
import { muiButton } from "./muiButton";
import { muiCheckbox } from "./muiCheckbox";
import { muiCssBaseline } from "./muiCssBaseline";
import { muiDialog } from "./muiDialog";
import { muiFormLabel } from "./muiFormLabel";
import { muiLink } from "./muiLink";
import { muiRadio } from "./muiRadio";
import { muiSelect } from "./muiSelect";
import { muiInput } from "./muiInput";
import { muiListItem } from "./muiListItem";
import { muiListItemIcon } from "./muiListItemIcon";
import { muiListItemText } from "./muiListItemText";
import { muiTab } from "./muiTab";
import { muiFormHelperText } from "./muiFormHelperText";
import { muiSnackbar } from "./muiSnackbar";
import { muiTypography } from "./muiTypography";

export const components = {
  ...muiAlert,
  ...muiButton,
  ...muiCheckbox,
  ...muiCssBaseline,
  ...muiDialog,
  ...muiListItem,
  ...muiListItemIcon,
  ...muiListItemText,
  ...muiFormLabel,
  ...muiLink,
  ...muiRadio,
  ...muiSelect,
  ...muiInput,
  ...muiTab,
  ...muiFormHelperText,
  ...muiSnackbar,
  ...muiTypography,
};
